import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    text-align: center;
`;

const Content = styled.div`
    width: 100%;
    max-width: 800px;
    text-align: left;
    overflow-y: auto;
    padding: 0 1rem;
`;

const SectionTitle = styled.p`
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
`;

const SubSectionTitle = styled.p`
    font-size: 1.1rem;
    font-weight: 600;
    margin-top: 1.2rem;
    margin-bottom: 0.5rem;
`;

const Paragraph = styled.p`
    margin-bottom: 0.8rem;
    line-height: 1.6;
`;

const SubParagraph = styled.p`
    margin-left: 1.5rem;
    margin-bottom: 0.5rem;
    line-height: 1.6;
`;

const Privacy = () => {
    return (
        <Wrapper>
            <Content>
                <SectionTitle>1. 개인정보의 처리 목적</SectionTitle>
                <Paragraph>('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회')은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</Paragraph>
                
                <SubSectionTitle>가. 홈페이지 회원가입 및 관리</SubSectionTitle>
                <Paragraph>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 만14세 미만 아동 개인정보 수집 시 법정대리인 동의 여부 확인, 각종 고지·통지, 고충처리 등을 목적으로 개인정보를 처리합니다.</Paragraph>
                
                <SubSectionTitle>나. 민원사무 처리</SubSectionTitle>
                <Paragraph>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.</Paragraph>
                
                <SubSectionTitle>다. 재화 또는 서비스 제공</SubSectionTitle>
                <Paragraph>서비스 제공, 콘텐츠 제공, 본인인증 등을 목적으로 개인정보를 처리합니다.</Paragraph>
                
                <SubSectionTitle>라. 마케팅 및 광고에의 활용</SubSectionTitle>
                <Paragraph>이벤트 및 광고성 정보 제공 및 참여기회 제공, 서비스의 유효성 확인 등을 목적으로 개인정보를 처리합니다.</Paragraph>
                
                <SectionTitle>2. 개인정보 파일 현황</SectionTitle>
                <SubSectionTitle>1. 개인정보 파일명 : 중앙대학교 총학생회 홈페이지 회원 개인정보</SubSectionTitle>
                <Paragraph>- 개인정보 항목 : 비밀번호 질문과 답, 비밀번호, 성별, 로그인ID, 이름, 이메일, 학력, 접속 IP 정보, 쿠키, 서비스 이용 기록, 접속 로그</Paragraph>
                <Paragraph>- 수집방법 : 홈페이지</Paragraph>
                <Paragraph>- 보유근거 : 중앙대학교 총학생회 홈페이지의 회원에 대한 원활한 서비스 제공</Paragraph>
                <Paragraph>- 보유기간 : 1년</Paragraph>
                <Paragraph>- 관련법령 : 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년</Paragraph>
                
                <SectionTitle>3. 개인정보처리 위탁</SectionTitle>
                <Paragraph>① '중앙대학교 서울캠퍼스 총학생회'은(는) 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</Paragraph>
                <Paragraph>② 'caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회'은(는) 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</Paragraph>
                <Paragraph>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</Paragraph>
                
                <SectionTitle>4. 정보주체의 권리, 의무 및 그 행사방법</SectionTitle>
                <Paragraph>이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.</Paragraph>
                <Paragraph>① 정보주체는 중앙대학교 서울캠퍼스 총학생회('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회) 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</Paragraph>
                <SubParagraph>1. 개인정보 열람요구</SubParagraph>
                <SubParagraph>2. 오류 등이 있을 경우 정정 요구</SubParagraph>
                <SubParagraph>3. 삭제요구</SubParagraph>
                <SubParagraph>4. 처리정지 요구</SubParagraph>
                <Paragraph>② 제1항에 따른 권리 행사는 중앙대학교 서울캠퍼스 총학생회('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회) 에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 ('사이트URL'이하 '사이트명) 은(는) 이에 대해 지체 없이 조치하겠습니다.</Paragraph>
                <Paragraph>③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 ('사이트URL'이하 '사이트명) 은(는) 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</Paragraph>
                <Paragraph>④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</Paragraph>
                
                <SectionTitle>5. 처리하는 개인정보의 항목</SectionTitle>
                <Paragraph>① ('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회')은(는) 다음의 개인정보 항목을 처리하고 있습니다.</Paragraph>
                <SubParagraph>- 필수항목 : 비밀번호 질문과 답, 비밀번호, 로그인ID, 이름, 이메일, 학력</SubParagraph>
                <SubParagraph>- 선택항목 : 성별, 휴대전화번호, 접속 IP 정보, 쿠키, 서비스 이용 기록, 접속 로그</SubParagraph>
                
                <SectionTitle>6. 개인정보의 파기</SectionTitle>
                <Paragraph>('중앙대학교 서울캠퍼스 총학생회')은(는) 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</Paragraph>
                
                <SubSectionTitle>-파기절차</SubSectionTitle>
                <Paragraph>이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.</Paragraph>
                
                <SubSectionTitle>-파기기한</SubSectionTitle>
                <Paragraph>이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.</Paragraph>
                
                <SubSectionTitle>-파기방법</SubSectionTitle>
                <Paragraph>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.</Paragraph>
                <Paragraph>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</Paragraph>
                
                <SectionTitle>7. 개인정보의 안전성 확보 조치</SectionTitle>
                <Paragraph>('중앙대학교 서울캠퍼스 총학생회')은(는) 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</Paragraph>
                
                <SubSectionTitle>1. 개인정보 취급 직원의 최소화 및 교육</SubSectionTitle>
                <Paragraph>개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.</Paragraph>
                
                <SubSectionTitle>2. 내부관리계획의 수립 및 시행</SubSectionTitle>
                <Paragraph>개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.</Paragraph>
                
                <SubSectionTitle>3. 개인정보에 대한 접근 제한</SubSectionTitle>
                <Paragraph>개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.</Paragraph>
                
                <SubSectionTitle>4. 접속기록의 보관 및 위변조 방지</SubSectionTitle>
                <Paragraph>개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.</Paragraph>
                
                <SubSectionTitle>5. 비인가자에 대한 출입 통제</SubSectionTitle>
                <Paragraph>개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.</Paragraph>
                
                <SectionTitle>8. 개인정보 보호책임자</SectionTitle>
                <Paragraph>① 중앙대학교 서울캠퍼스 총학생회('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회) 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</Paragraph>
                
                <SubSectionTitle>▶ 개인정보 보호책임자</SubSectionTitle>
                <Paragraph>성명 :채찬기</Paragraph>
                <Paragraph>직책 :중앙대학교 총학생회 홈페이지 관리자</Paragraph>
                <Paragraph>직급 :중앙대학교 총학생회 정책국장 채찬기</Paragraph>
                <Paragraph>연락처 :01053614044, ccr7979@naver.com</Paragraph>
                <Paragraph>※ 개인정보 보호 담당부서로 연결됩니다.</Paragraph>
                
                <SubSectionTitle>▶ 개인정보 보호 담당부서</SubSectionTitle>
                <Paragraph>부서명 :중앙대학교 총학생회</Paragraph>
                <Paragraph>담당자 :채찬기</Paragraph>
                <Paragraph>연락처 :028817371, sketch59th@gmail.com</Paragraph>
                
                <Paragraph>② 정보주체께서는 중앙대학교 서울캠퍼스 총학생회('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회) 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 중앙대학교 서울캠퍼스 총학생회('caugsa.com'이하 '중앙대학교 서울캠퍼스 총학생회) 은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</Paragraph>
                
                <SectionTitle>9. 개인정보 처리방침 변경</SectionTitle>
                <Paragraph>①이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</Paragraph>
            </Content>
        </Wrapper>
    );
};

export default Privacy;